import React, { useEffect, useMemo, useState } from "react";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";

import HomeGoogleAds from "../../components/advertisement/home-google-ads";
import CardsContainer from "./components/cardscontainer";
import Multiselect from "multiselect-react-dropdown";
import { useSelector } from "react-redux";
import { retrieveSearchFilters, retrieveSearchFiltersRegion, retrieveSearchFiltersProfInt } from "../../redux/slice/search-page/search-filter-options-slice";
import { RootState, useAppDispatch } from "../../redux/store";
import "../../assets/styles/search.css";
import { retrieveSearch } from "../../redux/slice/search-page/search-slice";
import { retrieveSearchRacExam } from "../../redux/slice/search-page/search-rac-exam-slice";
import { SearchPageRacExamsResponse } from "../../models/search-page/search-rac-exams-model";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import LoadingComp from "../../components/re-usable/loading/loading";

import LoadHomeGoogleAds from "../../components/advertisement/load-home-google-ads";
import { Helmet } from "react-helmet-async";
import { Taxonomy } from "../../models/search-page/search-filter-options-model";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";

export type MultiValueType = {
  value: number;
  label: string;
};

type FilterValues = {
  urlSearchMode: string;
  urlSearchtext: string;
  urlOrderBy: string;
  urlTaxonomy: string;
  urlSearchType: string;
  urlContentType: string;
  urlPageNumber: number;
};

const pageTabsData = [
  {
    displayText: "Recommended",
    nodeName: "recommended",
    iconClass: "material-icons-outlined",
    icon: "recommend",
  },
  {
    displayText: "News",
    nodeName: "news",
    iconClass: "material-icons-outlined",
    icon: "newspaper",
  },
  {
    displayText: "Events",
    nodeName: "events",
    iconClass: "material-icons-outlined",
    icon: "event_available",
  },
  {
    displayText: "Books",
    nodeName: "books",
    iconClass: "material-icons-outlined",
    icon: "book",
  },
  {
    displayText: "Courses",
    nodeName: "courses",
    iconClass: "material-icons-outlined",
    icon: "co_present",
  },
  {
    displayText: "Exams",
    nodeName: "exams",
    iconClass: "material-icons-outlined",
    icon: "workspace_premium",
  },
  {
    displayText: "More",
    nodeName: "more",
    iconClass: "material-icons-outlined",
    icon: "fact_check",
  },
];

export const RacExam = (props: { data: SearchPageRacExamsResponse[] }) => {

  function boldText(matchText: string) {
    $('.description').each(function () {
      let text = $(this).html();
      if (text.indexOf(matchText) !== -1) {
        // Wrap the text with a <span> tag
        text = text.replace(matchText, '<b>' + matchText + '</b>');
        $(this).html(text);
      }
    });
  }

useEffect(() => {
  $(function () {
    boldText("Testing Window :")
    boldText("Registration Deadline :")
  });
  }, [props.data]);

  return (
    <div className="row">
      {props?.data[0]?.totalSearchResults === 0 ?
        <p className="py-4"><b>The exam application window will open soon.</b></p>
        : props?.data[0]?.searchResultsList?.map((item, index) => {
          return (
            <div className="col-md-3 center-img-label text-center" style={{ marginTop: 15, marginBottom: 15 }} key={index}>
              <span className="category-type category-raps-product ">
                <span className="category-text">
                  <span dangerouslySetInnerHTML={{ __html: item.productBadge }}></span>
                </span>
              </span>
              <div className="product-img">
                <Link to={`/products/${item.nodeName}`}>
                  <img alt="" src={item.imageUrl} />
                </Link>
              </div>

              <h5 className="title text-center" style={{ margin: "5px 0" }}>
                <Link to={`/products/${item.nodeName}`}>{item.name}</Link>
              </h5>
              {item.isEvent ? <span className="meta-item date text-left">{item.formattedDate}</span> : ""}
              {item.educationCredits !== "0.0" ? (
                <div className="products">
                  <span className="meta-item rac-credits">
                    <span style={{ margin: "3px 0" }} className="rac-credits">
                      <span style={{ marginRight: 6 }} className="badge badge-credits">
                        {" "}
                        {item.educationCredits}{" "}
                      </span>
                      <span className="badge-label">RAC Credits</span>{" "}
                    </span>
                  </span>
                </div>
              ) : (
                ""
              )}

              <div className="description small" style={{ textAlign: "left" }} dangerouslySetInnerHTML={{ __html: item.shortDescription }}></div>
            </div>
          );
        })}
    </div>
  );
};

const Search = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  let [queryParams] = useSearchParams();
  let taxonomy = queryParams.get("taxonomy") || "";
  let searchtext = queryParams.get("searchtext") || "";
  let searchtypeTab = queryParams.get("searchtype") || "recommended";
  //let contenttypeTab = queryParams.get("contenttype") || "all";

  const defaultFilterValues = {
    urlSearchMode: queryParams.get("searchmode") || "",
    urlSearchtext: queryParams.get("searchtext") || "",
    urlOrderBy: queryParams.get("orderby") || "",
    urlTaxonomy: queryParams.get("taxonomy") || "",
    urlSearchType: queryParams.get("searchtype") || "recommended",
    urlContentType: queryParams.get("contenttype") || "all",
    urlPageNumber: Number(queryParams.get("pagenumber")) || 1,
  };
  const [filterValues, setFilterValues] = useState<FilterValues>(defaultFilterValues);

  // const [mappedOptionsFilter, setMappedOptionsFilter] = useState<{ taxonomyId: number; categoryName: string }[]>([]);
  // const [mappedOptionsFilterRegion, setMappedOptionsFilterRegion] = useState<{ taxonomyId: number; categoryName: string }[]>([]);
  // const [mappedOptionsFilterProfInt, setMappedOptionsFilterProfInt] = useState<{ taxonomyId: number; categoryName: string }[]>([]);

  //let sectorQuery = (filterArray: any[]) => filterArray?.filter((item: { taxonomyId: string }) => String(item.taxonomyId) === taxonomy);

  const filter = useSelector((state: RootState) => state.searchFilters.filterData);

  const filterRegion = useSelector((state: RootState) => state.searchFiltersRegion.filterData);

  const filterProfInt = useSelector((state: RootState) => state.searchFiltersProfInt.filterData);

  // Extract IDs for each MultiSelect from URL
  const ids1 = taxonomy.split(";");
  const ids2 = taxonomy.split(";");
  const ids3 = taxonomy.split(";");

  // Map IDs to options for each MultiSelect
  // const [selectedFilter, SetselectedFilter] = useState<Taxonomy[]>()
  const selectedFilter: Taxonomy[] = [];
  const selectedFilterRegion: Taxonomy[] = [];
  const selectedFilterProfInt: Taxonomy[] = [];
  ids1.filter((id) => filter.map((item) => item.taxonomyId.toString() === id && selectedFilter.push(item)));
  ids2.filter((id) => filterRegion.map((item) => item.taxonomyId.toString() === id && selectedFilterRegion.push(item)));
  ids3.filter((id) => filterProfInt.map((item) => item.taxonomyId.toString() === id && selectedFilterProfInt.push(item)));

  let getTaxonamyIdsSector = selectedFilter?.map((item) => item.taxonomyId);
  const defaultSector = getTaxonamyIdsSector.join(";");

  let getTaxonamyIdsRegion = selectedFilterRegion?.map((item) => item.taxonomyId);
  const defaultRegion = getTaxonamyIdsRegion.join(";");

  let getTaxonamyIdsProfessionalInterest = selectedFilterProfInt?.map((item) => item.taxonomyId);
  const defaultProfessionalInterest = getTaxonamyIdsProfessionalInterest.join(";");

  const [keyword, setKeyword] = useState<string>(searchtext);
  const [sector, setSector] = useState<string>("");
  const [region, setRegion] = useState<string>("");
  const [professionalInterest, setProfessionalInterest] = useState<string>("");
  const [taxonomyIds, setTaxonomyIds] = useState<string>(taxonomy || `${sector};${region};${professionalInterest}`);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [searchType, setSearchType] = useState<string>(searchtypeTab);
  //const [contentType, setContentType] = useState<string>(contenttypeTab);
  const [relevance, setRelevance] = useState<string>("relevance");
  const [isDispatching, setIsDispatching] = useState(false);

  useEffect(() => {
    defaultSector.length > 0 && setSector(defaultSector);
    defaultRegion.length > 0 && setRegion(defaultRegion);
    defaultProfessionalInterest.length > 0 && setProfessionalInterest(defaultProfessionalInterest);
  }, [defaultSector, defaultRegion, defaultProfessionalInterest]);

  let SearchQueryParamsType = {
    searchText: keyword,
    taxonomyIds: taxonomyIds,
    pageNumber: pageNumber,
    searchType: searchType,
    //contentType: contentType,
    relevance: relevance,
  };

  useEffect(() => {
    setIsDispatching(true);

    dispatch(retrieveSearchFilters());
    dispatch(retrieveSearchFiltersRegion());
    dispatch(retrieveSearchFiltersProfInt());
    dispatch(retrieveSearchRacExam(1));
    dispatch(retrieveSearch(SearchQueryParamsType)).then(() => {
      setIsDispatching(false);
    });
  }, []);

  useEffect(() => {
    if (
      defaultFilterValues.urlSearchtext !== keyword ||
      (defaultFilterValues.urlOrderBy !== relevance && defaultFilterValues.urlOrderBy !== "") ||
      defaultFilterValues.urlTaxonomy !== taxonomyIds ||
      defaultFilterValues.urlSearchType !== searchType ||
      //defaultFilterValues.urlContentType !== contentType ||
      defaultFilterValues.urlPageNumber !== pageNumber
    ) {
      if (isDispatching) return;
      setIsDispatching(true);

      let newkeyword = defaultFilterValues.urlSearchtext || "";
      let newrelevance = defaultFilterValues.urlOrderBy || "relevance";
      let newtaxonomy = defaultFilterValues.urlTaxonomy || "";
      let newsearchType = defaultFilterValues.urlSearchType || "recommended";
      //let newcontentType = defaultFilterValues.urlContentType || "all";
      let newpageNumber = defaultFilterValues.urlPageNumber || 1;

      if (defaultFilterValues.urlSearchtext !== keyword) setKeyword(newkeyword);
      if (defaultFilterValues.urlOrderBy !== relevance && defaultFilterValues.urlOrderBy !== "") setRelevance(newrelevance);
      if (defaultFilterValues.urlTaxonomy !== taxonomyIds) setTaxonomyIds(newtaxonomy);
      if (defaultFilterValues.urlSearchType !== searchType && defaultFilterValues.urlSearchType !== "") setSearchType(newsearchType);
      //if (defaultFilterValues.urlContentType !== contentType && defaultFilterValues.urlSearchType === "marketplace") setSearchType(newcontentType);
      if (defaultFilterValues.urlPageNumber !== pageNumber) setPageNumber(newpageNumber);

      let SearchQueryParamsType = {
        searchText: newkeyword,
        taxonomyIds: newtaxonomy,
        pageNumber: newpageNumber,
        searchType: newsearchType,
        //contentType: newcontentType,
        relevance: newrelevance,
      };

      dispatch(retrieveSearch(SearchQueryParamsType)).then(() => {
        setIsDispatching(false);
      });
    }
  }, [location]);

  const searchResultsRacExamData = useSelector((state: RootState) => state.searchRacExam.searchResultsRacExamData);

  const { searchData, loading } = useSelector((state: RootState) => state.search);

  // Update URL
  const updateUrl = (urlSearchMode?: string, urlSearchtext?: string, urlOrderBy?: string, urlTaxonomy?: string, urlSearchType?: string, urlContentType?: string, urlPageNumber?: number) => {
    const urlSearchParams = new URLSearchParams();
    urlSearchMode && urlSearchParams.append("searchmode", urlSearchMode);
    urlSearchtext && urlSearchParams.append("searchtext", urlSearchtext);
    urlOrderBy && urlOrderBy !== "relevance" && urlSearchParams.append("orderby", urlOrderBy);
    urlTaxonomy && urlSearchParams.append("taxonomy", urlTaxonomy);
    urlSearchType && urlSearchParams.append("searchtype", urlSearchType);
    //urlSearchType === "marketplace" && urlContentType && urlSearchParams.append("contenttype", urlContentType);
    urlPageNumber && urlPageNumber !== 1 && urlSearchParams.append("pagenumber", urlPageNumber.toString());
    navigate(`/search?${urlSearchParams.toString()}`);
  };

  const handleSearchKeyWord = (value: string) => {
    setKeyword(value);
    const urlSearchtext = value;
    const urlPageNumber = 1;
    setPageNumber(urlPageNumber);
    setFilterValues((prevFilterValues) => ({ ...prevFilterValues, urlSearchtext, urlPageNumber }));
  };

  const handleSort = (value: string) => {
    console.log(filterValues);
    setRelevance(value);
    const urlOrderBy = value;
    setFilterValues((prevFilterValues) => ({ ...prevFilterValues, urlOrderBy }));
  };

  const handleSector = (list: { taxonomyId: number }[]) => {
    let sectorElements: number[] = [];

    list.map((item) => {
      sectorElements.push(item.taxonomyId);
    });

    let joinSectorElements = sectorElements.length > 0 ? sectorElements.join(";") + ";" : "";
    setSector(joinSectorElements);
  };

  const handleRegion = (list: { taxonomyId: number }[]) => {
    let regionElements: number[] = [];

    list.map((item: { taxonomyId: number }) => {
      regionElements.push(item.taxonomyId);
    });

    let joinRegionElements = regionElements.length > 0 ? regionElements.join(";") + ";" : "";
    setRegion(joinRegionElements);
  };

  const handleProfessionalInterest = (list: { taxonomyId: number }[]) => {
    let professionalInterestElements: number[] = [];

    list.map((item: { taxonomyId: number }) => {
      professionalInterestElements.push(item.taxonomyId);
    });

    let joinProfessionalInterest = professionalInterestElements.length > 0 ? professionalInterestElements.join(";") + ";" : "";
    setProfessionalInterest(joinProfessionalInterest);
  };

  const getPageNumber = (data: number) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const urlPageNumber = data;

    setPageNumber(urlPageNumber);
    setFilterValues((prevFilterValues) => ({ ...prevFilterValues, urlPageNumber }));

    if (isDispatching) return;
    setIsDispatching(true);

    let includeSector = sector.length > 0 ? sector : "";
    let includeRegion = region.length > 0 ? region : "";
    let includeProfInt = professionalInterest.length > 0 ? professionalInterest : "";
    let urlTaxonomy = `${includeSector};${includeRegion};${includeProfInt}`;

    SearchQueryParamsType = {
      searchText: keyword,
      taxonomyIds: urlTaxonomy,
      pageNumber: data,
      searchType: searchType,
      //contentType: contentType,
      relevance: relevance,
    };
    dispatch(retrieveSearch(SearchQueryParamsType)).then(() => {
      setIsDispatching(false);
    });

  };

  const handleSubmit = () => {
    if (isDispatching) return;
    setIsDispatching(true);

    let urlSearchText = keyword;
    let urlPageNumber = 1;
    let urlSearchType = searchType;
    //let urlContentType = contentType;
    let urlOrderBy = relevance;

    let includeSector = sector.length > 0 ? sector : "";
    let includeRegion = region.length > 0 ? region : "";
    let includeProfInt = professionalInterest.length > 0 ? professionalInterest : "";
    let urlTaxonomy = `${includeSector};${includeRegion};${includeProfInt}`;

    SearchQueryParamsType = {
      searchText: urlSearchText,
      taxonomyIds: urlTaxonomy,
      pageNumber: urlPageNumber,
      searchType: urlSearchType,
      //contentType: urlContentType,
      relevance: urlOrderBy,
    };

    // setTaxonomyIds(urlTaxonomy);
    setPageNumber(urlPageNumber);
    setFilterValues((prevFilterValues) => ({ ...prevFilterValues, urlSearchText, urlTaxonomy, urlPageNumber, urlSearchType, urlOrderBy }));
    dispatch(retrieveSearch(SearchQueryParamsType)).then(() => {
      setIsDispatching(false);
    });
  };

  const searchKeyDownButtonHandler = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };

  const handleReset = () => {
    if (isDispatching) return;
    setIsDispatching(true);

    let resetFilterValues = {
      urlSearchMode: "",
      urlSearchtext: "",
      urlOrderBy: "",
      urlTaxonomy: "",
      urlSearchType: "recommended",
      urlContentType: "all",
      urlPageNumber: 1,
    };

    setSector("");
    setRegion("");
    setProfessionalInterest("");
    setSearchType("recommended");
    //setContentType("all");
    setKeyword("");
    setTaxonomyIds("");
    setPageNumber(1);
    setRelevance("relevance");
    setFilterValues(resetFilterValues);

    SearchQueryParamsType = {
      searchText: "",
      taxonomyIds: "",
      pageNumber: 1,
      searchType: "recommended",
      //contentType: "all",
      relevance: "relevance",
    };
    dispatch(retrieveSearch(SearchQueryParamsType)).then(() => {
      setIsDispatching(false);
    });
  };

  const handleSearchType = (displayName: string) => {
    //if (isDispatching) return;
    setIsDispatching(true);

    const urlPageNumber = 1;
    const urlSearchType = displayName;
    //const urlContentType = contentName ?? "all";
    const urlOrderBy = (displayName === "more") ? "newest" : "relevance"

    setSearchType(urlSearchType);
    setRelevance(urlOrderBy)
    //setContentType(urlContentType)
    setPageNumber(urlPageNumber);
    setFilterValues((prevFilterValues) => ({ ...prevFilterValues, urlSearchType, urlPageNumber, urlOrderBy }));

    let includeSector = sector.length > 0 ? sector : "";
    let includeRegion = region.length > 0 ? region : "";
    let includeProfInt = professionalInterest.length > 0 ? professionalInterest : "";
    let urlTaxonomy = `${includeSector};${includeRegion};${includeProfInt}`;

    SearchQueryParamsType = {
      searchText: keyword,
      taxonomyIds: urlTaxonomy,
      pageNumber: 1,
      searchType: displayName,
      //contentType: urlContentType,
      relevance: urlOrderBy,
    };

    dispatch(retrieveSearch(SearchQueryParamsType)).then(() => {
      setIsDispatching(false);
    });
  };

  useEffect(() => {
    updateUrl(filterValues.urlSearchMode, filterValues.urlSearchtext, filterValues.urlOrderBy, filterValues.urlTaxonomy, filterValues.urlSearchType, filterValues.urlContentType, filterValues.urlPageNumber);
  }, [filterValues]);

  // useEffect(() => {
  //   if (isDispatching) return;
  //   setIsDispatching(true);

  //   SearchQueryParamsType = {
  //     searchText: keyword,
  //     taxonomyIds: taxonomyIds,
  //     pageNumber: pageNumber,
  //     searchType: searchType,
  //     relevance: relevance,
  //   };
  //   console.log(taxonomyIds)
  //   dispatch(retrieveSearch(SearchQueryParamsType)).then(() => {
  //     setIsDispatching(false);
  //   });
  // }, [searchType]);

  // useEffect(() => {
  //   if (isDispatching) return;
  //   setIsDispatching(true);

  //   SearchQueryParamsType = {
  //     searchText: keyword,
  //     taxonomyIds: taxonomyIds,
  //     pageNumber: pageNumber,
  //     searchType: searchType,
  //     relevance: relevance,
  //   };
  //   dispatch(retrieveSearch(SearchQueryParamsType)).then(() => {
  //     setIsDispatching(false);
  //   });
  // }, [pageNumber]);

  const cachedGoogleAds = useMemo(() => <HomeGoogleAds />, []);
  const cachedLoadGoogleAds = useMemo(() => <LoadHomeGoogleAds />, []);

  // Page published check
  const { RapsEuropeData } = useSelector((state: RootState) => state.rapsEurope);
  const [isPublished, setIsPublished] = useState(false);

  useEffect(() => {
    dispatch(retrievePageMenu(`%2FSearch`));
  }, [dispatch]);

  useEffect(() => {
    if (RapsEuropeData[0]?.result !== undefined) {
      setIsPublished(true);
    }
  }, [RapsEuropeData]);

  if (!isPublished) return <LoadingComp />;
  // End Page published check

  return (
    <>
      <Helmet>
        <title>{searchData[0]?.menuItemName}</title>
      </Helmet>
      <main id="site-main" className="site-main">
        <div className="site-top"></div>
        <div className="container">
          <div className="page-tools row">
            <div className="col-sm-8 col-lg-9">
              <div className="breadcrumb"></div>
            </div>
            <div className="col-sm-4 col-lg-3"></div>
          </div>
          <div dangerouslySetInnerHTML={{ __html: RapsEuropeData[0]?.result[0]?.description }}></div>
        </div>
        <div className="container two-column">
          <div className="row">
            <div className="col-md-7">
              <h1 className="h1 page-sub-title" style={{ margin: 0 }}>
                Search Results
              </h1>
            </div>
            <div className="col-md-5">
              <a href="https://my.raps.org/shopping-cart/">
                <span className="menu-icon float-right">
                  <span className="cart material-icons-outlined" style={{ verticalAlign: "middle" }}>
                    shopping_cart
                  </span>
                  <span className="cart-text" style={{ verticalAlign: "middle" }}>
                    Shopping Cart
                  </span>
                </span>
              </a>
            </div>
          </div>

          <div className="filter fitler-event-search">
            <div className="FormPanel">
              <div className="container">
                <div className="row">
                  <div className="col-md-4 col-xl-3">
                    <div className="row">
                      <div className="col-md-12 cus-form-group">
                        <label htmlFor="keywordField" className="EditingFormLabel">
                          Keyword
                        </label>
                        <input
                          name="keywordField"
                          type="text"
                          id="keywordField"
                          value={keyword}
                          onKeyDown={searchKeyDownButtonHandler}
                          className="SearchFilterField form-control"
                          onChange={(e) => {
                            handleSearchKeyWord(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-xl-2">
                    <div className="row">
                      <div className="col-md-12 cus-form-group">
                        <label htmlFor="sectorField">Sector</label>

                        <Multiselect
                          className="basic-multi-select"
                          // placeholder={addAuditorName?.length ? '' : 'Employees Name'}
                          showArrow
                          options={filter?.map((item) => item)}
                          onRemove={handleSector}
                          selectedValues={selectedFilter}
                          onSelect={handleSector}
                          displayValue="categoryName"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-xl-2">
                    <div className="row">
                      <div className="col-md-12 cus-form-group">
                        <label htmlFor="regionField">Region</label>
                        <Multiselect
                          className="basic-multi-select"
                          options={filterRegion?.map((item) => item)}
                          showArrow
                          onRemove={handleRegion}
                          selectedValues={selectedFilterRegion}
                          onSelect={handleRegion}
                          displayValue="categoryName"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-xl-2">
                    <div className="row">
                      <div className="col-md-12 cus-form-group">
                        <label htmlFor="professionalInterestField">Professional Interest</label>
                        <Multiselect
                          className="basic-multi-select"
                          options={filterProfInt?.map((item) => item)}
                          showArrow
                          selectedValues={selectedFilterProfInt}
                          onSelect={handleProfessionalInterest}
                          onRemove={handleProfessionalInterest}
                          displayValue="categoryName"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-xl-1">
                    <div className="row">
                      <div className="col-md-12 cus-form-group">
                        <label htmlFor="sortByField" className="EditingFormLabel">
                          Sort By
                        </label>
                        <select onChange={(e) => handleSort(e.target.value)} name="sortByField" id="sortByField" className="test form-control px-0" value={relevance}>
                          <option value="relevance">Relevance</option>
                          <option value="newest">Newest</option>
                          <option value="oldest">Earliest</option>
                          <option value="title">Alphabetical</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-xl-2">
                    <input type="submit" name="submitButton" value="Search" id="submitButton" className="btn btn-default" onKeyDown={searchKeyDownButtonHandler} onClick={() => handleSubmit()} />
                    <button type="reset" id="btnReset" className="btn btn-plain" onClick={() => handleReset()} style={{ backgroundColor: "white", borderRadius: 0 }}>
                      Reset
                    </button>
                  </div>

                  <div className="col-md-1"></div>
                </div>
              </div>
            </div>
          </div>
          <div>&nbsp;</div>

          <div className="tabbs">
            <Tab.Container id="left-tabs-example" activeKey={searchType}>
              <Row>
                <Col sm={12}>
                  <Nav className="d-flex nav-tabs flex-wrap">
                    {pageTabsData &&
                      pageTabsData?.map((tab, index) => {
                        const displayText = tab.nodeName.toLocaleLowerCase();
                        return (
                          <Nav.Item key={index}>
                            <Nav.Link eventKey={displayText} onClick={() => handleSearchType(displayText)}>
                              <span className={tab.iconClass}>{tab.icon}</span>
                              <span className="searchtag" style={{ verticalAlign: "top" }}>
                                {tab.displayText}
                              </span>
                            </Nav.Link>
                          </Nav.Item>
                        );
                      })}
                  </Nav>
                </Col>
                {loading ? (
                  <LoadingComp />
                ) : (
                  <Col sm={12}>
                    <Tab.Content className="category">
                      <Tab.Pane eventKey="recommended">
                        <CardsContainer data={searchData} getPageNumber={getPageNumber} pageNumber={pageNumber} isNews={false} />
                      </Tab.Pane>
                      <Tab.Pane eventKey="news">
                        <CardsContainer
                          data={searchData} getPageNumber={getPageNumber} pageNumber={pageNumber}
                          title={[{ name: "News Search", pageUrl: "/news-and-articles/news-articles", },]}
                          isNews={true}
                        />
                      </Tab.Pane>
                      <Tab.Pane eventKey="events">
                        <CardsContainer
                          data={searchData} getPageNumber={getPageNumber} pageNumber={pageNumber}
                          title={[
                            { name: "Event Calendar", pageUrl: "/events", },
                          ]}
                          isNews={false}
                        />
                      </Tab.Pane>
                      <Tab.Pane eventKey="books">
                        <CardsContainer
                          data={searchData} getPageNumber={getPageNumber} pageNumber={pageNumber}
                          title={[
                            { name: "Full Books Catalog", pageUrl: "/education/books", },
                          ]}
                          isNews={false}
                        />
                      </Tab.Pane>
                      <Tab.Pane eventKey="courses">
                        <CardsContainer data={searchData} getPageNumber={getPageNumber} pageNumber={pageNumber}
                          title={[
                            { name: "Full Learning Catalog", pageUrl: "/education/courses", },
                          ]}
                          isNews={false}
                        />
                      </Tab.Pane>
                      <Tab.Pane eventKey="exams">
                        <RacExam data={searchResultsRacExamData} />
                      </Tab.Pane>
                      <Tab.Pane eventKey="more">
                        <CardsContainer data={searchData} getPageNumber={getPageNumber} pageNumber={pageNumber} isNews={false} />
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                )}
              </Row>
            </Tab.Container>
          </div>
        </div>
        <div className="container my-4">
          {cachedGoogleAds}
          {cachedLoadGoogleAds}
        </div>
      </main>
    </>
  );
};

export default Search;
